import { getAPIURL } from '../helper/helper';

const apiURL = getAPIURL();

const channelAPPConfig = {
	api: {
		PORTAL_DOMAIN: `${apiURL}`,
		DS_DOMAIN: `${apiURL}/channelperformance/core`,
		CP_PROFILE_DOMAIN: `${apiURL}/channelperformance/profile`,
		CP_FINDINGS_DOMAIN: `${apiURL}/channelperformance/profile`,
		CP_PERFORMANCE: `${apiURL}/channelperformance/performance`,
		CP_TREND: `${apiURL}/channelperformance/trend`,
		CP_GRID: `${apiURL}/channelperformance/grid`,
		SEARCH: `${apiURL}/channelperformance/search`,
		BREAKDOWN: `${apiURL}/channelperformance/breakdown`,
		SUMMARY: `${apiURL}/channelperformance/summary`,
		MAP_SUMMARY: `${apiURL}/channelperformance/map`,
		CUSTOM_RULE: `${apiURL}/channelperformance/customrule`,
		EVENT_TRACK: `${apiURL}/channelperformance/eventprcsr/v1/api/publish`,
		INTELLIFGENT_FEEDBACK: `${apiURL}/channelperformance/profile/feedback/search`,
		USER_PREF: `${apiURL}/channelperformance/userpref`,
		TABLE_GRAPHQL: `${apiURL}/channelperformance/tablemetrics/graphql`,
		METRICS: `${apiURL}/channelperformance/search/metrics`,
		METRICS_ECOM: `${apiURL}/channelperformance/search/metrics?channel=ECOM`,
		METRICS_STORE: `${apiURL}/channelperformance/search/metrics?channel=STORE`,
		GET_PREFERENCES: `${apiURL}/channelperformance/userpref/v1/lookup?preference=4`,
		SAVE_PREFERENCES: `${apiURL}/channelperformance/userpref/v1/save?preference=4`,
		DOWNLOAD_IN_EXCEL: `${apiURL}/channelperformance/filegenerate/v1/metrics/download`,
		DATA_REFRESH: `${apiURL}/channelperformance/search/data-refresh`,
		USER_AUTH: `${apiURL}/core-app-api/user-info`,
		AD_GRAPHQL: `${apiURL}/channelperformance/guided-insights/graphql`,
		GRAPHQL: `${apiURL}/graphql`,
	},
};

export default channelAPPConfig;
